<template>
  <div class="md-layout">
    <md-card
      class="md-layout-item md-size-66 md-medium-size-100"
      style="margin: 0 auto"
    >
      <badges />
    </md-card>
  </div>
</template>

<script>
import Badges from "../pages/Dashboard/Pages/UserProfile/Badges";

export default {
  components: { Badges }
}
</script>
